import type { DashboardMetric } from "../type";
import { SegmentsGroupMonthlyVisitsGraphWidget } from "./SegmentsGroupMonthlyVisitsGraphWidget";

export class SegmentsPagePerVisitGroupGraphWidget extends SegmentsGroupMonthlyVisitsGraphWidget {
    protected metric: DashboardMetric;
    protected dataSource;

    constructor() {
        super();
        this.dataSource = "PagePerVisit";
        this.metric = "SegmentsPagePerVisitGroup";
    }

    static getWidgetDashboardType() {
        return "Graph";
    }

    static getWidgetResourceType() {
        return "Graph";
    }

    static getWidgetMetadataType() {
        return "SegmentsPagePerVisitGroupGraph";
    }
}

SegmentsPagePerVisitGroupGraphWidget.register();
